import React, { Component } from 'react';
import RangePicker from "react-range-picker";
import moment from 'moment';
// import calendar from '../../resource/svg/calendar.svg';


class CalendarioRango extends Component {
    state = {
        startDate: localStorage.getItem("fechaInicial"),
        endDate: localStorage.getItem("fechaFinal"),
    }

    // seleccionarFecha = (fechaInicio, fechaFin) => {
        
    // }   

    guardarFecha = (fechaInicio, fechaFin) => {
        if(fechaInicio && fechaFin){
            let fechaArrayIni = moment(fechaInicio).format('L').split('/');
            let fechaArrayFin = moment(fechaFin).format('L').split('/');
            this.setState({
                startDate: fechaArrayIni[2] + '-' + fechaArrayIni[0] + '-' + fechaArrayIni[1] ,
                endDate: fechaArrayFin[2] + '-' + fechaArrayFin[0] + '-' + fechaArrayFin[1] 
            }, ()=> {
                this.props.onChangeRangoFechas(this.state.startDate, this.state.endDate);
                document.getElementsByClassName("text")[0].innerHTML = this.state.startDate + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + this.state.endDate;
            })
        } 
        else
        {
            let fechaArrayIni = moment(fechaInicio).format('L').split('/');
            let fechaArrayFin = moment(fechaFin).format('L').split('/');
            this.setState({
                startDate: fechaArrayIni[2] + '-' + fechaArrayIni[0] + '-' + fechaArrayIni[1] ,
                endDate: fechaArrayFin[2] + '-' + fechaArrayFin[0] + '-' + fechaArrayFin[1] 
            }, ()=> {
                this.props.onChangeRangoFechas(this.state.startDate, this.state.endDate);
                document.getElementsByClassName("text")[0].innerHTML = this.state.startDate + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + this.state.endDate;
            })
        }
    }   

    componentDidMount(){

        document.getElementsByClassName('default-placeholder')[0].id = "calendarPortalCobranzas";

        document.getElementsByClassName("select")[0].innerHTML = "Seleccionar";
        
        document.getElementsByClassName("text")[0].className = "text calendario-desk";
        // document.getElementsByClassName("text")[0].innerHTML = "Desde&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hasta";
        document.getElementsByClassName("text")[0].innerHTML = this.state.startDate + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' + this.state.endDate;
    }

    onCalendario = () => {
        document.getElementById('calendarPortalCobranzas').click();
    }
    

    render(){
       return(
        <><RangePicker  
            id="calendarPortalCobranzas"
            // onDateSelected={this.seleccionarFecha}
            // startDate={this.state.startDate}
			// endDate={this.state.endDate}
			placeholderText = "Fecha de Envío"
            onOk={this.guardarFecha}
            // value={ this.state.startDate +' - '+this.state.endDate }
            g={this.state.monthsFull}
            h={this.state.monthsShort}
            enableRange={true} 
			style = {{marginTop:0}}
			/>
            
            {/* <img className="imgCalendar pointer" src={calendar} alt="" onClick={this.onCalendario} /> */}
        </>
       )
    }
}


export default CalendarioRango;